import { useEffect, useState } from "react";
import { DeleteRoomApi, GetRoomsApi } from "../../services/Api";
import { isAdmin, isAuthenticated } from "../../services/Auth";
import { MDBDataTable } from "mdbreact";
import { toast } from 'react-toastify';
import AdminNavBar from "./AdminNavBar";
import { Link } from "react-router-dom";
import { Navigate } from 'react-router-dom';



export default function AllRoomDetails() {

    const [loading, setLoading] = useState(false);
    const [rooms, setRooms] = useState([]);
    const [update, setUpdate] = useState(0);


    useEffect(() => {
        if (isAuthenticated() && isAdmin()) {
            setLoading(true);
            GetRoomsApi().then((response) => {
                setRooms(response.data.rooms)
            })
            setLoading(false);
        }
    }, [update])

    const roomData = () => {
        const data = {
            columns: [
                {
                    label: 'ID  ↕',
                    field: 'id',
                    sort: 'asc'
                },
                {
                    label: 'Name   ↕',
                    field: 'name',
                    sort: 'asc'
                },
                {
                    label: 'Price   ↕',
                    field: 'price',
                    sort: 'asc'
                },
                {
                    label: 'Category   ↕',
                    field: 'category',
                    sort: 'asc'
                },
                {
                    label: 'Vacancies   ↕',
                    field: 'vacancies',
                    sort: 'asc'
                },
                {
                    label: 'Actions   ↕',
                    field: 'actions',
                    sort: 'asc'
                }
            ],
            rows: []
        }

        const deleteHandler = async(e, id) => {
            e.target.disabled = true;
            DeleteRoomApi(id);
            toast.success("Room Deleted Successfully");
            await new Promise(resolve => setTimeout(resolve, 5000));
            setUpdate(update+1);
            e.target.disabled = false;
        }

        rooms.forEach(room => {
            data.rows.push({
                id: room._id,
                name: room.name,
                price : `Rs. ${room.price}`,
                category: room.category,
                vacancies: room.vacancies,
                actions: (
                    <>
                        <Link to={`/admin/updateroom/${room._id}`} className="btn btn-primary"> <i className="fa fa-pencil"></i></Link>
                        <button onClick={e => deleteHandler(e, room._id)} className="btn btn-danger py-1 px-2 ml-2">
                            <i className="fa fa-trash"></i>
                        </button>
                    </>)
            })
        })

        return data;
    }

    if (!isAuthenticated() || !isAdmin()) {
        return <Navigate to="/login" />
    }

    return (
        <>
        <AdminNavBar />
            <div className="container-fluid p-5 bg-body-secondary">
                <h1>Room List</h1>
                <div className="bg-body-tertiary bg-opacity-50">
                    {!loading &&
                        <MDBDataTable
                            data={roomData()}
                            bordered
                            striped
                            hover
                            className="px-3"
                        />
                    }
                </div>
            </div>
        </>
    )
}
